import { CloudStore } from './cloudStore'
import { MemoryStore } from './memoryStore'
import { JsonStore } from './types'
import type { ProgressStore } from './types'
import { getWebApp } from '../telegram/sdk'

export * from './types'
export { MemoryStore } from './memoryStore'
export { CloudStore } from './cloudStore'

/**
 * Единая точка создания хранилища.
 *
 * Решение принимается синхронно по наличию CloudStorage у текущего
 * WebApp. Вне Telegram getWebApp() отдаёт mock, у которого CloudStorage
 * работает в памяти - так что ветка Cloud безопасна в обоих случаях.
 */
export function createStore(): ProgressStore {
  try {
    if (!getWebApp().CloudStorage) return new MemoryStore()
    return new CloudStore()
  } catch {
    return new MemoryStore()
  }
}

export const store = new JsonStore(createStore())
